import {
  useRouteError,
  isRouteErrorResponse,
  useNavigate,
} from 'react-router-dom'
import { Box, Typography, Button, Paper } from '@mui/material'
import { RiErrorWarningLine } from '@/shared/icons/remix'
import { logger } from '@/lib/logger'
import { NotFoundPage } from './NotFoundPage'

export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  let title = 'Something went wrong'
  let description = 'An unexpected error occurred. Please try again.'

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      logger.error('Route error response', {
        status: error.status,
        statusText: error.statusText,
        data: error.data,
      })
      return <NotFoundPage homeTo="/" />
    }
    if (error.status === 403) {
      title = 'Access denied'
      description = "You don't have permission to view this page."
    } else {
      title = `Error ${error.status}`
      description = error.statusText || description
    }
    logger.error('Route error response', {
      status: error.status,
      statusText: error.statusText,
      data: error.data,
    })
  } else {
    logger.error('Unhandled route error', {
      err: error instanceof Error ? error : new Error(String(error)),
    })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 480,
          p: 4,
          textAlign: 'center',
        }}
      >
        <Box
          component="span"
          sx={{ color: 'error.main', mb: 2, display: 'inline-flex' }}
        >
          <RiErrorWarningLine size={64} aria-hidden />
        </Box>
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Go back
          </Button>
          <Button variant="contained" onClick={() => navigate('/')}>
            Go home
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
